import { Link } from 'react-router-dom'
import { SocialMedia } from 'components/common/SocialMedia'
import { FaCircle, FaInfoCircle } from 'react-icons/fa'
import { getNoBidClientStyle } from 'utils/helpers'
import s from './Title.scss'
import { SALUTATIONS } from 'components/common/modals/ContactModalContainer/constants'
import { UncontrolledTooltip } from 'reactstrap'

const Title = ({
  firstName,
  lastName,
  facebook,
  twitter,
  linkedin,
  instagram,
  title,
  company,
  salutation,
  breadCrumb
}) => (
  <section className={s.contactMain}>
    <div className={s.title}>
      <div className={s.userInfo}>
        <h4>
          {salutation ? SALUTATIONS.find(s => s.value === salutation).label : ''} {firstName}{' '}
          {lastName}
        </h4>
        <FaCircle className={s.circle} />
        <div className={s.socialMediaContainer}>
          <SocialMedia
            facebook={facebook}
            twitter={twitter}
            linkedin={linkedin}
            instagram={instagram}
          />
        </div>
        <p style={{ marginBottom: 0, fontSize: 14, color: '#007bff' }}>
          {breadCrumb}
          <FaInfoCircle id="Type1" style={{ marginLeft: 5 }} />
          <UncontrolledTooltip placement="top" target="Type1">
            This is the email address of your contact. Emails sent to this email address will be
            saved under the contact notes
          </UncontrolledTooltip>
        </p>
      </div>
      <div className={s.companyInfo}>
        <span>{title}</span>
        <FaCircle className={s.circle} />
        <Link
          className={s.link}
          to={`/companies/${company.id}`}
          style={getNoBidClientStyle(company.noBid)}
        >
          {company.name}
        </Link>
      </div>
    </div>
  </section>
)

export default Title
